import PropTypes from 'prop-types';
import { fullWeek } from '../constants/date-format';

export const PickupSettingsDayPropType = PropTypes.shape({
  shipFromContactId: PropTypes.string,
  instructions: PropTypes.string,
  day: PropTypes.oneOf(fullWeek),
  startTime: PropTypes.string,
  endTime: PropTypes.string,
  preferredTime: PropTypes.string,
  pickPackTime: PropTypes.string,
});

/**
 * @typedef {object} PickupSettingsDayPropType
 * @property {string} shipFromContactId
 * @property {string} instructions
 * @property {(
 *   'Monday'|
 *   'Tuesday'|
 *   'Wednesday'|
 *   'Thursday'|
 *   'Friday'|
 *   'Saturday'|
 *   'Sunday'
 * )} day
 * @property {string} startTime
 * @property {string} endTime
 * @property {string} preferredTime
 * @property {string} pickPackTime
 */
